<div style="display: flex;flex-direction: row;flex:1;align-self: center;">
    <mat-card style="margin-top: 25px;margin-left: 2%;margin-right: 2%;"> 
        <span style="font-size: 25px;">{{'Warranty Type Setup' | translate | async}}</span>

        <div class="search-options"
        style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap; flex-direction: column;">

      
        <div >   
          <h4 style="font-weight: bold; font-size: 18px;" class="get-label">{{'Warranty Type' | translate | async}}</h4>
          <div style="display: flex;">
             <mat-form-field style="width: 400px">
               <mat-label>{{'Enter Warranty Type Name' | translate | async}}</mat-label>
                 <input type="text" matInput placeholder="{{'Enter Warranty Type Name' | translate | async}}" [(ngModel)]="warrantyTypeName" required>            
             </mat-form-field>       
          </div>
        </div>      
  
        <div>
          <h4 style="font-weight: bold; font-size: 18px;" class="get-label">{{'Include' | translate | async}}</h4>
          <div style="display: flex; flex-direction: column;">
            <div >
            
                <mat-form-field style="width: 400px"> 
                  <mat-label>{{'Hours Usage' | translate | async}}</mat-label>
                  <input type="text" matInput placeholder="{{'Enter Hours' | translate | async}}" [(ngModel)]="Hours" required>            
              </mat-form-field>  
            </div>
            <div >
             
                <mat-form-field style="width: 400px; ">  
                  <mat-label>{{'Days' | translate | async}}</mat-label>  
                  <input type="text" matInput placeholder="{{'Enter Days' | translate | async}}" [(ngModel)]="Days" required>            
              </mat-form-field>  
            </div>
            <div>
              
                <mat-form-field style="width: 400px;">   
                  <mat-label>{{'Cycles' | translate | async}}</mat-label> 
                  <input type="text" matInput placeholder="{{'Enter Cycles' | translate | async}}" [(ngModel)]="NoOfCycles">            
              </mat-form-field>  
            </div>

            <div>
              
              <mat-form-field style="width: 400px;">   
                <mat-label>{{'Status' | translate | async}}</mat-label>  
                <mat-select placeholder="{{'Select Status' | translate | async}}" [(ngModel)]="selectStatus">
                  <mat-option [value]=1>{{'Active' | translate | async}}</mat-option>
                  <mat-option [value]=0>{{'In-Active' | translate | async}}</mat-option>
                </mat-select>    
            </mat-form-field>  

           
          </div>
            
            </div>             
          </div>
       
        <div style="display: flex;flex-direction: row;justify-content: flex-end;align-self: flex-end;">     
          <button style="margin-left: 20px;" class="button button--primary" (click)="Reset()"><span
              class="button__text" >{{'Reset' | translate | async}}</span></button>
           <button style="margin-left: 20px;" class="button button--primary" (click)="SaveWarranty()"><span
              class="button__text" >{{'Save/Update' | translate | async}}</span></button>     
        </div>

    </div>   
    <div >
      <table class="table table--full-width table--striped" style="margin-top: 9px;">      
        <thead>
          <tr>        
           <th>{{'Warranty Type' | translate | async}}</th>
           <th>{{'Hours' | translate | async}}</th>
           <th>{{'Days' | translate | async}}</th>
           <th>{{'Cycles' | translate | async}}</th>
           <th>{{'Status' | translate | async}}</th>       
          </tr>
        </thead>
         <tbody>
           <ng-container *ngIf="warrantyList!=null">
            <tr *ngFor="let warranty of warrantyList" (click)="RowClick(warranty)">      
              <td style="cursor: pointer;">{{warranty.Type}}</td>
              <td style="cursor: pointer;">{{warranty.Hours}}</td>
              <td style="cursor: pointer;">{{warranty.Days}}</td>
              <td style="cursor: pointer;">{{warranty.NoOfCycles}}</td>
              <td style="cursor: pointer;">{{warranty.Status == 1 ? ('Active' | translate | async) : ('In-Active' | translate | async)}}</td>
           </tr>    
           </ng-container>    
         
        </tbody>   
      </table>
    
 </div>
</mat-card>

  
    
</div>